import { render, staticRenderFns } from "./spend.vue?vue&type=template&id=2965c88a"
import script from "./spend.vue?vue&type=script&lang=js"
export * from "./spend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports